@import "tailwindcss";

/* PKU (Peking University) Theme Colors
 * Primary: #94070a (北大红)
 * Secondary: #c9a227 (金色)
 * Accent: #f4e8d0 (米黄)
 */

@layer base {
  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

@layer utilities {
  /* Line clamp utilities */
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  /* Custom scrollbar */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #d4a5a6;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94070a;
  }
}

/* Animation keyframes */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}

/* Table specific styles - PKU Theme */
.papers-table tr {
  transition: background-color 0.2s ease;
}

.papers-table tr:hover {
  background-color: rgba(148, 7, 10, 0.05);
}

/* Focus visible for accessibility - PKU Red */
*:focus-visible {
  outline: 2px solid #94070a;
  outline-offset: 2px;
}

/* Remove default button styles */
button {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

/* Link styles */
a {
  text-decoration: none;
  color: inherit;
}

/* Selection color - PKU Red */
::selection {
  background-color: rgba(148, 7, 10, 0.2);
  color: inherit;
}
